import React, { useState, } from 'react';
import { makeStyles, } from '@mui/styles';
import {
  Grid,
  Typography,
} from '@mui/material';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
} from '@mui/icons-material';
import { Interfaces, } from '../../../../config';
import {
  StyledButton,
  StyledTextField,
} from '../../../Reusable';

const useStyles = makeStyles(() => ({
  textField: {
    paddingRight: 30,
  },
  paddingBottom: {
    paddingBottom: '2%',
  },
  labelsWrapper: {
    marginTop: 10,
    marginBottom: 10,
  },
  labelWrapper: {
    marginRight: 10,
    display: 'inline',
  },
  addBtn: {
    minHeight: 39,
    marginLeft: 22,
  },
}));

interface Props {
  // eslint-disable-next-line no-unused-vars
  onAddAttribute: (attribute: { key: string; value: string}) => void;
  // eslint-disable-next-line no-unused-vars
  onRemoveAttribute: (attribute: string) => void;
  alert: Interfaces.Alert;
  readOnly?: boolean;
}

const Headers = (props: Props) => {
  const classes = useStyles();
  const [state, setState,] = useState<{key: string; value: string}>({
    key: '',
    value: '',
  });

  const {
    onAddAttribute,
    onRemoveAttribute,
    alert,
    readOnly,
  } = props;

  const renderAttribute = (key: string, value: string) => {
    return (
      <Grid container style={{ marginBottom: 10, }}>
        <Grid item xs={5}>
          <StyledTextField
            disabled
            id="disabled"
            fullWidth
            label="Key"
            value={key}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={5}>
          <StyledTextField
            disabled
            id="disabled"
            label="Value"
            fullWidth
            value={value}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={2}>
          <StyledButton
            variant="contained"
            color="secondary"
            className={classes.addBtn}
            onClick={() => {
              if (onRemoveAttribute) {
                onRemoveAttribute(key);
              }
            }}
          >
            <RemoveIcon />
          </StyledButton>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.labelWrapper} variant="subtitle1">
          Headers:
        </Typography>
      </Grid>
      <Grid container>
        <Grid item xs={5}>
          <StyledTextField
            disabled={readOnly}
            name="key"
            label="Key"
            fullWidth
            variant="outlined"
            size="small"
            value={state.key}
            onChange={(event) => {
              setState({
                ...state,
                key: event.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={5}>
          <StyledTextField
            disabled={readOnly}
            name="value"
            label="Value"
            fullWidth
            style={{
              marginLeft: 10,
            }}
            variant="outlined"
            size="small"
            value={state.value}
            onChange={(event) => {
              setState({
                ...state,
                value: event.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={1}>
          <StyledButton
            variant="contained"
            color="primary"
            disabled={state.key === '' || state.value === '' || readOnly}
            onClick={() => {
              onAddAttribute(state);
              setState({
                key: '',
                value: '',
              });
            }}
            className={classes.addBtn}
          >
            <AddIcon fontSize={'small'} />
          </StyledButton>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.labelsWrapper}>
        {alert.outputRule.rule['headers'] && Object.keys(alert.outputRule.rule['headers']).map((key: string) => (
          renderAttribute(key, alert.outputRule.rule['headers'][key])
        ))}
      </Grid>
    </Grid>
  );
};

export { Headers, };
